class Footer {
	constructor() {
		this.socials();
	}

	socials() {
		if ($('body').find('#newletter-bar').length) {
			$('.footer-socials').remove();
			$('.footer-logo-col').removeClass('col-lg-6');
		}
	}
}

export default new Footer();